export const POSTHOG_COOKIE_KEY = 'ph_bootstrapData';
